import { EQUIPMENT_TYPE } from "@store/Equipments/actionTypes";
import { entries, fromEntries } from "@utils/entries";
import {
  EditorData3,
  PlaceEditorsData3,
  SerializedEditorData3,
  SerializedNodeTree3,
  SerializedPlaceEditorsData3,
  toNodeTree3,
  toSerializedNodeTree3,
} from "./types";

export const serializeEditorData = (dt: EditorData3): SerializedEditorData3 => ({
  ...dt,
  tree: toSerializedNodeTree3(dt.tree),
});

export const deserializeEditorData = (dt: SerializedEditorData3): EditorData3 => ({
  ...dt,
  tree: toNodeTree3(dt.tree as SerializedNodeTree3),
});

export const serializePlacedEditorData = (
  dt: PlaceEditorsData3
): SerializedPlaceEditorsData3 => ({
  ...dt,
  kinds: fromEntries(
    entries(dt.kinds).map(([k, v]) => [k as EQUIPMENT_TYPE, serializeEditorData(v)])
  ),
});

export const deserializePlacedEditorData = (
  dt: SerializedPlaceEditorsData3
): PlaceEditorsData3 => ({
  ...dt,
  kinds: fromEntries(
    entries(dt.kinds).map(([k, v]) => [k as EQUIPMENT_TYPE, deserializeEditorData(v)])
  ),
});

